export interface BannerRow {
  flexRowReverse: boolean;
  hasBorder: boolean;
}

export interface BannerHeader {
  text: string;
  level: string;
}
